export default {
  methods: {
    getError(obj) {
      if (Object.keys(this.$t('errors')).includes(obj.error)) {
        return this.$t(`errors.${obj.error}`)
      } else {
        return obj.error
      }
    }
  }
}
